<template>
<div>
    
    
    <vx-card class="">
        <!-- <v-select class="searchSelect" placeholder="검색조건"  :value="page.pageSize" v-model='page.pageSize' :clearable="false" :options="optionData.showNumber"/> -->
        <span>총 장르 수 : {{total}}</span>
         
        <div>
            <vue-good-table
                :columns="genreTable.column"
                :rows="tableData"
                :scroll-width="1600"
                >
                    <template slot="table-row" slot-scope="props">
                         <span v-if="props.column.field == 'status'">
                            {{props.row.status == "awaiting_response" ? '답변대기' : '답변완료'}}
                        </span>
                        <span v-if="props.column.field == 'subject'" @click="$router.push('/support/inquiry/'+props.row.id)" style="cursor:pointer; color:#4a90e2">
                            {{props.row.subject}}
                        </span>
                        <span v-if="props.column.field == 'user'"  >
                            <a :href="'/member/detail/'+ props.row.user_id" style="cursor:pointer; " target="_blank">{{props.row.user.email}}</a>
                        </span>
                      
                    </template>
            </vue-good-table>
        </div>
        <!-- <div class="paginationBox">
            <base-pagination :page-count="page.totalPage" v-model="page.currentPage"></base-pagination>
        </div> -->
    </vx-card>
    
     
</div>
</template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
 
export default {
    name: 'genreList',
  
    data () {
        return {
      
            total : 0,
            page: {
                pageSize : 10,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            tableData : [],
            genreTable : {
                column : [
                     
                     
                    {label: '상태',    field: 'status', sortable: false, filter: false,width:'100px' },
                    {label: '제목',    field: 'subject', sortable: false, filter: false, },
                    {label: '작성자',    field: 'user', sortable: false, filter: false, width:'250px'},
                    
                    {label: '등록일', field: 'created_at', sortable: false, filter: false,minWidth: 140,width:'200px' , formatFn: (data) => {
                        return this.fixDate(data, 'yyyy-MM-dd')
                    }},
                   
                ]
            }
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
         this.callList()
        })
    },
    computed: {
    
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        callList(){
            const option = {
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
                //is_various_artists: false, // 필수 filter
            }
            
            let query = {}

            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }   
            this.$router.replace({query: query}).catch((e)=>{});
            
            this.loadingShow()

            this.$store.dispatch('LIST_TICKET', option)
            .then(result =>{
                this.loadingHide()
                this.tableData  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){
        this.page.currentPage = 1  // 초기화
        this.callList()
        },

        genreVisible(data){
            let payload = {
                id : data.id,
                params : {
                    "visible": !data.visible,
                }
            }
            console.log(payload)
            this.confirm({
                title : '장르삭제 확인',
                msg : `
                    선택하신 장르 상태를 ${!data.visible ? '노출' : '비노출'}로 변경하시겠습니까?
                `,
                autofocus : true,
                width:400,
                action : ()=>{
                    this.loadingShow()
                    this.$store.dispatch('PUT_GENRE', payload)
                    .then(result =>{
                        this.closeModal('confirm')
                        this.loadingHide()
                        this.callList()
                    }).catch(error=>{
                        const status = error.response.status
                        this.loadingHide()
                        switch(status){
                            case 401:
                            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                            break;
                            default:
                                this.alert({msg : error.response.data.message})
                            break;
                        }
                    })
                }
            })
        },
        genreEdit(data){
            this.genreId = data.id 
            this.genreName = data.name_english; 
            this.genreCategory = data.category;
            this.ddexGenreName = data.ddex;
            this.apple = data.apple;
            this.fuga = data.fuga
            this.audiblemagic = data.audiblemagic
            this.openModal('genreEdit')
        },
        genreSave(){
            let payload ={
                "id" : this.genreId,
                params : {
                    "name_english": this.genreName,
                    "name_korean": '',
                    "ddex" : this.ddexGenreName,
                    "category": this.genreCategory,
                    'apple' : this.apple,
                    'fuga':this.fuga,
                    'audiblemagic':this.audiblemagic
                }
                
            }
            if(this.valCheck(this.genreName) && this.valCheck(this.genreCategory) && this.valCheck(this.ddexGenreName) ){
                this.alert({msg : '카테고리와 이름을 확인해주세요.'})
                return false
            }
            this.loadingShow()
            this.$store.dispatch('PUT_GENRE', payload)
            .then(result =>{
                this.closeModal('genreEdit')
                this.callList()
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        genreDelete(id){
            this.confirm({
                title : '장르삭제 확인',
                msg : `
                    선택하신 장르를 삭제하시겠습니까?
                `,
                autofocus : true,
                width:400,
                action : ()=>{
                    this.loadingShow()
                    this.$store.dispatch('DELETE_GENRE', {id:id})
                    .then(result =>{
                        this.closeModal('confirm')
                        this.loadingHide()
                        this.callList()
                    }).catch(error=>{
                        const status = error.response.status
                        this.loadingHide()
                        switch(status){
                            case 401:
                            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                            break;
                            default:
                                this.alert({msg : error.response.data.message})
                            break;
                        }
                    })
                }
            })
        },
        genrePost(event){
            let payload ={
                "name_english": this.genreName,
                "name_korean": '',
                "ddex" : this.ddexGenreName,
                "category": this.genreCategory,
                'apple' : this.apple,
                'fuga':this.fuga,
                'audiblemagic':this.audiblemagic
            }
            if(this.valCheck(this.genreName) && this.valCheck(this.genreCategory) && this.valCheck(this.ddexGenreName) ){
                this.alert({msg : '카테고리와 이름을 확인해주세요.'})
                return false
            }
            this.loadingShow()
            this.$store.dispatch('POST_GENRE', payload)
            .then(result =>{
                this.closeModal('genre')
                this.loadingHide()
                this.callList()
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
